<template>
  <footer class="footer">
    <div class="container footer__main">
      <img
        class="footer__logo"
        :src="data.site.logo"
        alt="Templiers Valley"
      >
      <p class="footer__address">{{ data.contact.address }}</p>
      <a
        class="footer__line"
        :href="`tel:${data.contact.phone.replace(/\s/g, '')}`"
      >{{ data.contact.phone }}</a>
      <a
        class="footer__line"
        :href="`mailto:${data.contact.email}`"
      >{{ data.contact.email }}</a>
      <button
        class="btn-pill is-red footer__cta"
        @click="$emit('open-contact')"
      >
        <BtnStar />
        {{ data.contact.ctaLabel }}
      </button>
    </div>
    <div class="footer__bottom">
      <div class="container footer__bottom-inner">
        <span>{{ data.contact.copyright }}</span>
        <router-link
          v-for="link in data.contact.footerLinks"
          :key="link.label"
          :to="link.href"
        >{{ link.label }}</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import BtnStar from '@/components/BtnStar.vue'

export default {
  name: 'SiteFooter',
  components: { BtnStar },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['open-contact']
}
</script>

<style lang="scss" scoped>
.footer {
  background: $navy;
  color: $white;
}

.footer__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 72px 0 56px;
  text-align: center;
}

.footer__logo {
  height: 72px;
  margin-bottom: 18px;
}

.footer__address,
.footer__line {
  font-size: 15px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.92);
}

.footer__line:hover {
  color: $yellow;
}

.footer__cta {
  margin-top: 22px;
}

.footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  padding: 20px 0;
}

.footer__bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);

  a:hover {
    color: $yellow;
  }

  @include mobile {
    gap: 8px;
    font-size: 10.5px;
    white-space: nowrap;
  }
}
</style>
